import React, { useState } from "react";
import { Input, Select, Button } from "antd";
import { FilterOutlined } from "@ant-design/icons";
import { useLocations } from "../../hooks/useLocation";
// import { useCategories } from "../../hooks/useCategories";
import { useVendors } from "../../hooks/useVendors";
import { useAuth } from "../../hooks/useAuth";

const { Option } = Select;

interface InventoryFiltersProps {
  onApplyFilters: (filters: Record<string, any>) => void;
  onClearFilters: () => void;
  canSeeAllLocations: boolean; // New prop for location permission
}

const InventoryFilters: React.FC<InventoryFiltersProps> = ({
  onApplyFilters,
  onClearFilters,
  canSeeAllLocations,
}) => {
  const { data: user } = useAuth();
  const locationId = user?.location?.id;

  const [filters, setFilters] = useState<Record<string, any>>({
    location_id: canSeeAllLocations ? undefined : locationId,
  });

  // Get locations, categories, and vendors data
  const { data: locations, isLoading: isLoadingLocations } = useLocations();
  // const { data: categories } = useCategories();
  const { data: vendors, isLoading: isLoadingVendors } = useVendors(1, {});

  const handleFilterChange = (key: string, value: any) => {
    setFilters((prev) => ({ ...prev, [key]: value }));
  };

  return (
    <div className="bg-white p-4 shadow-md rounded-lg space-y-3">
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-4">
        <div>
          <Input
            placeholder="Product Name"
            value={filters.name || ""}
            onChange={(e) => handleFilterChange("name", e.target.value)}
          />
        </div>
        {/* <div>
          <Select
            placeholder="Category"
            className="w-full"
            value={filters.category_id || undefined}
            onChange={(value) => handleFilterChange("category_id", value)}
          >
            {categories?.data?.map((category) => (
              <Option key={category.id} value={category.id}>
                {category.name}
              </Option>
            ))}
          </Select>
        </div> */}
        <div>
          <Select
            placeholder="Vendor"
            className="w-full"
            value={filters.vendor_id || undefined}
            loading={isLoadingVendors}
            onChange={(value) => handleFilterChange("vendor_id", value)}
          >
            {vendors?.data?.map((vendor) => (
              <Option key={vendor.id} value={vendor.id}>
                {vendor.name}
              </Option>
            ))}
          </Select>
        </div>
        <div>
          <Select
            placeholder="Availability"
            className="w-full"
            value={filters.status || undefined}
            onChange={(value) => handleFilterChange("status", value)}
          >
            <Option value={1}>Available</Option>
            <Option value={0}>Unavailable</Option>
          </Select>
        </div>
        {/* <div>
          <Select
            placeholder="Available Stock"
            className="w-full"
            value={filters.qty || undefined}
            onChange={(value) => handleFilterChange("qty", value)}
          >
            <Option value="low">Low in Stock (≤10)</Option>
            <Option value="in_stock">In Stock ({">"}10)</Option>
          </Select>
        </div> */}
        {canSeeAllLocations && (
          <div>
            <Select
              placeholder="Location"
              className="w-full"
              loading={isLoadingLocations}
              value={filters.location_id || undefined}
              onChange={(value) => handleFilterChange("location_id", value)}
            >
              {locations?.map((loc) => (
                <Option key={loc.id} value={loc.id}>
                  {loc.name}
                </Option>
              ))}
            </Select>
          </div>
        )}
      </div>

      <div className="flex justify-end space-x-3">
        <Button
          type="primary"
          icon={<FilterOutlined />}
          onClick={() => onApplyFilters(filters)}
        >
          Apply Filters
        </Button>
        <Button
          onClick={() => {
            setFilters({
              location_id: canSeeAllLocations ? undefined : locationId,
            });
            onClearFilters();
          }}
        >
          Clear Filters
        </Button>
      </div>
    </div>
  );
};

export default InventoryFilters;
